import Price from '~/utils/Price/Price';

export default function calculateProductPackagePrice(
	price: Price,
	packageSize: number,
	referencePackageSize: number
): Price {
	return new Price(String((Number(price.value) / packageSize) * referencePackageSize), price.currency);
}
